import * as THREE from 'three';
import {BuildTree, KDTree, Node, MeasuredPoint, SearchNode} from "./KDTree";
import { ClosePath } from '../objects/ClosePath';

export class NearPointSearch {
    
    // 部屋の保持
    private rooms: ClosePath[] = [];
    // treeの保持
    private tree: SearchNode;
    // 差分デフォルトの値
    private distance: number = 100;

    constructor() {
        this.distance = 100;
        this.tree = null;
    }
    
    // 部屋登録
    public addRoom(closePath: ClosePath): void {
        this.rooms.push(closePath);
    }

    // tree作成
    public create(): boolean {
        if (!this.rooms.length) {
            console.warn("aaaaaaa");
            return false;
        }

        // const nodes: Node[] = [];
        const kdtree = new BuildTree();

        this.rooms.forEach((room: ClosePath, roomIndex) => {
            room.position.forEach((point: THREE.Vector2, pointIndex) => {
                const node = new Node(point);
                node.data = {roomindex: roomIndex, pointIndex: pointIndex};
                
                kdtree.add(node);
            });
           
        });
        this.tree = kdtree.buildTree();
        return true;
    }

    // ほぼ一致する点がどの部屋の何番目のポイントなのか探索
    public search(pos: THREE.Vector2) {
        return new KDTree().searchDist(this.tree, pos, this.distance)
                    .map((value: MeasuredPoint) => value.userdata);
    }

    // 距離を設定する 
    public setDistance(distance: number): void {
        if ( distance <= 0 ) {
            console.warn("distance error !!!!");
        }
        this.distance = distance;
    }

}